import React, { createContext, useContext } from 'react';

interface DashboardContextType {
  sessionExpiryTime: number | null;
  onSessionExpire: () => void;
  userProfile: any;
}

const DashboardContext = createContext<DashboardContextType | undefined>(undefined);

export const useDashboard = () => {
  const context = useContext(DashboardContext);
  if (context === undefined) {
    throw new Error('useDashboard must be used within a DashboardProvider');
  }
  return context;
};

export const DashboardProvider: React.FC<{ 
  children: React.ReactNode; 
  value: DashboardContextType 
}> = ({ children, value }) => {
  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
};
